import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const RADIAN = Math.PI / 180;

// Function to render custom labels on the arc
const renderCustomLabel =
  (data) =>
  ({ cx, cy, midAngle, outerRadius, index }) => {
    const radius = outerRadius * 0.9; // Adjust position to be on the arc
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const color = index === 0 ? '#D946EF' : '#6366F1'; // Color-matching
    const name = data[index]?.name || ''; // Prevent undefined error
    const count = data[index]?.value || 0; // Show actual count instead of percentage

    return (
      <>
        {/* Bigger White Circle Behind the Text */}
        <circle
          cx={x}
          cy={y}
          r={30}
          fill="white"
          stroke="rgba(0, 0, 0, 0.1)"
          strokeWidth={1}
        />

        {/* Count Text */}
        <text
          x={x}
          y={y}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={14}
          fontWeight="bold"
          fill={color}
        >
          {count} {/* Show count instead of percentage */}
        </text>
        <text
          x={x}
          y={y + 16} // Position below the count
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={10}
          fontWeight="bold"
          fill="black"
        >
          {name}
        </text>
      </>
    );
  };

const BudgetChart = ({ MaleFemale }) => {
  const data = [
    {
      name: 'Male',
      value: MaleFemale.male_practitioners || 0,
      color: '#4F46E5',
    }, // Blue
    {
      name: 'Female',
      value: MaleFemale.female_practitioners || 0,
      color: '#D946EF',
    }, // Purple
  ];

  const total = data.reduce((acc, curr) => acc + curr.value, 0);

  console.log('totaltotaltotal', total);

  return (
    <div className="flex flex-col items-center">
      <div className="relative flex flex-col items-center">
        <PieChart width={400} height={250}>
          <Pie
            data={data}
            cx="50%"
            cy="100%"
            startAngle={180}
            endAngle={0}
            innerRadius={100} // Thicker arc
            outerRadius={130}
            dataKey="value"
            stroke="none"
            labelLine={false} // Remove the line
            label={renderCustomLabel(data)} // Pass `data` into closure
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
        <div className="absolute bottom-5 text-center">
          <span className="text-gray-700 font-bold text-lg">
            Total: {total}
          </span>
        </div>
      </div>
      {/* Labels and Total Amount */}

      <div className="flex justify-between w-full mt-4 px-10 mb-5 border-t-2 border-#E2E4E9-400 pt-2">
        {/* Male Section */}

        <div className="flex flex-col items-center flex-1 border-r border-gray-300">
          <span className="text-gray-500 text-sm">Male</span>
          <span className="text-gray-900 font-bold text-lg">
            {MaleFemale.male_practitioners || 0}
          </span>
        </div>

        {/* Vertical Divider */}
        <div className="h-10 border-l border-gray-300"></div>

        {/* Remaining Budget */}
        <div className="flex flex-col items-center flex-1">
          <span className="text-gray-500 text-sm">Female</span>
          <span className="text-gray-900 font-bold text-lg">
            {MaleFemale.female_practitioners || 0}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BudgetChart;
